import { GET_REASON_BEGIN, GET_REASON_SUCCESS } from "./type";

const initialState = {
    items: [],
    loading: false
}
export const ReasonReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_REASON_BEGIN:
            return {
                ...state,
                loading: true
            }
        case GET_REASON_SUCCESS:
            return action.payload
        default:
            return state
    }
};
